export default "__VITE_ASSET__BrXRwDg6__"